import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { formattedCurrencyValue } from "../../utils/currencyUtils";

import "./index.scss";

const BoxCompontent = ({ title, value, percentageValue, volume, days, id }) => {
  const { t } = useTranslation();
  const volumeUnit = useSelector((state) => state.volume);
  const currency = useSelector((state) => state.currency);

  value = isNaN(value)
    ? ""
    : value < 0
      ? ` ${formattedCurrencyValue(value, currency)}`
      : ` ${formattedCurrencyValue(value, currency)}`;

  const getClassname = (value) => {
    return parseFloat(value) <= 0
      ? "negative-box-information"
      : "box-information";
  };

  return (
    <div className="box-container" id={id}>
      <div className="box-title">{title}</div>
      {percentageValue != null && (
        <div
          className={`${getClassname(percentageValue)} marginTop10`}
          id={`${title}-percentage`}
        >
          {percentageValue === "-Infinity"
            ? ""
            : `${
                parseFloat(percentageValue) === 0
                  ? "0"
                  : parseFloat(percentageValue).toFixed(2)
              } %`}
        </div>
      )}
      {volume != null && (
        <div
          className={`${getClassname(volume)} marginTop10 flex-jc-center`}
          id={`${title}-volume`}
        >
          {value && <span>{value}</span>} <span>&nbsp; (</span>
          {parseFloat(volume) === 0 ? 0 : parseFloat(volume).toFixed(2)}{" "}
          {volumeUnit === "m3" ? (
            <span>
              m<sup>3</sup>
            </span>
          ) : (
            volumeUnit
          )}
          <span>)</span>
        </div>
      )}
      {days != null && (
        <div
          className={`${getClassname(days)} marginTop10 flex-jc-center`}
          id={`${title}-days`}
        >
          {value && <span>{value}</span>} <span>&nbsp; (</span>
          {parseFloat(days) === 0 ? 0 : parseFloat(days).toFixed(2)}
          &nbsp;{days > 1 ? t("ValueStrings.days") : t("ValueStrings.day")}
          <span>)</span>
        </div>
      )}
      {value != null && volume == null && days == null && (
        <div
          className={`${getClassname(value)} marginTop10`}
          id={`${title}-value`}
        >
          {value}
        </div>
      )}
    </div>
  );
};

export default BoxCompontent;
